import React, { useState } from 'react';
import Filters from './Filters';
import HomeDetails from './Home-Details';
import Footer from './Footer';

function Advisory() {
    const [advisoryData, setAdvisoryData] = useState(null); // Manage advisoryData here
    const [selectedFilters, setSelectedFilters] = useState(null);

    return (
        <>
            <div className="wrapper pt-100px">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12 col-md-3 col-lg-3">
                            {/* Pass setAdvisoryData as a prop to Filters */}
                            <Filters setAdvisoryData={setAdvisoryData} setSelectedFilters={setSelectedFilters} />
                        </div>
                        <div className="col-sm-12 col-md-9 col-lg-9">
                            {/* Conditionally render HomeDetails only if advisoryData exists */}
                            <HomeDetails advisoryData={advisoryData} selectedFilters={selectedFilters} />
                        </div>
                    </div>
                </div>
                <Footer />
            </div>


        </>
    );
}

export default Advisory;